// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import urls from  '@src/@core/auth/jwt/urls'
// ** Axios Imports
import axios from 'axios'
import { errorToast, sucessToast } from '../../../../components/messageToast/messageToast'

const instance = axios.create({
  baseURL: urls.url,
  timeout: 15000,
  headers: {Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "application/json"}
})

export const getAvailableAssistants = createAsyncThunk('appCaseAssistants/getAvailableAssistants', async (id) => {
  const response = await instance.get(`/cases/${id}/available_assistants/`)
  return response.data
})

export const addAssistants = createAsyncThunk('appCaseAssistants/addAssistants', async ({id, assistant_ids}) => {
  try {
    const response = await instance.post(`/cases/${id}/assistants/`, {assistants: assistant_ids})
    sucessToast("Asistentes añadidos correctamente")
    return response.data
  } catch (e) {
    errorToast(e.response?.data?.msg ?? 'Hubo problemas al añadir asistentes')
    throw e
  }
})

export const removeAssistant = createAsyncThunk('appCaseAssistants/removeAssistant', async ({id, profile_id}) => {
  try {
    await instance.delete(`/cases/${id}/assistants/${profile_id}/`)
    sucessToast("Asistente removido correctamente")
    return profile_id
  } catch (e) {
    errorToast(e.response?.data?.msg ?? 'Hubo problemas al remover el asistente')
    throw e
  }
})

export const appCaseAssistantsSlice = createSlice({
  name: 'appCaseAssistants',
  initialState: {
    available: [],
    loading: false
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getAvailableAssistants.fulfilled, (state, action) => {
        state.available = action.payload ?? []
      })
  }
})

export default appCaseAssistantsSlice.reducer
